import axios from 'axios';

const API_BASE_URL = 'https://ptsspl.in/public/api';

export interface User {
  id: number;
  name: string;
  email: string;
  role: string;
  department: string;
  created_at: string;
  updated_at: string;
}

class UserService {
  async getAll(): Promise<User[]> {
    try {
      const response = await axios.get(`${API_BASE_URL}/users`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch users');
    }
  }

  async getById(id: number): Promise<User> {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/${id}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch user');
    }
  }

  async create(userData: Omit<User, 'id' | 'created_at' | 'updated_at'>): Promise<User> {
    try {
      const response = await axios.post(`${API_BASE_URL}/users`, userData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to create user');
    }
  }

  async update(id: number, userData: Partial<Omit<User, 'id' | 'created_at' | 'updated_at'>>): Promise<User> {
    try {
      const response = await axios.put(`${API_BASE_URL}/users/${id}`, userData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update user');
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/users/${id}`);
    } catch (error) {
      throw new Error('Failed to delete user');
    }
  }
}

const userService = new UserService();
export default userService;